import { useQuery } from '@tanstack/react-query';
import { checkFeatureFlags } from '@/lib/api/feature-flags';

/**
 * Returns whether a single feature flag is enabled for the current workspace.
 *
 * staleTime is intentionally 30s (not 5min from the original plan):
 * 60s backend cache + 5min frontend = up to 6min toggle latency (ADR-015 P2).
 * 30s frontend reduces max latency to ~90s.
 *
 * @param name - Feature flag name (e.g. 'tool.amazon_title')
 * @returns `true` when the flag is enabled, `false` while loading or when disabled.
 */
export function useFeatureFlag(name: string): boolean {
  const { data } = useQuery({
    queryKey: ['feature-flags', 'check', name],
    queryFn: () => checkFeatureFlags([name]),
    staleTime: 30 * 1000,
  });
  return data?.enabled.includes(name) ?? false;
}
